
import { TranslationsByLanguage } from './types';

export type ChannelsTranslationKey =
  | 'channels.allChannels'
  | 'channels.searchPlaceholder'
  | 'channels.view'
  | 'channel.subscribe'
  | 'channel.subscribers'
  | 'channel.clips'
  | 'channel.playlists'
  | 'channel.recentClips'
  | 'channel.about'
  | 'channel.aboutTitle'
  | 'channel.longDescription'
  | 'channel.licenseInfo'
  | 'channel.licenseDescription'
  | 'channel.notFound'
  | 'channel.notFoundDescription'
  | 'channel.noPlaylists'
  | 'channel.noClips'
  | 'explore.channels.title'
  | 'explore.channels.description'
  | 'channels.description'
  | 'channels.noChannels';

export const channelsTranslations: TranslationsByLanguage = {
  en: {
    'channels.allChannels': 'All Channels',
    'channels.searchPlaceholder': 'Search channels...',
    'channels.view': 'View Channel',
    'channel.subscribe': 'Subscribe',
    'channel.subscribers': 'subscribers',
    'channel.clips': 'clips',
    'channel.playlists': 'Playlists',
    'channel.recentClips': 'Recent Clips',
    'channel.about': 'About',
    'channel.aboutTitle': 'About this Channel',
    'channel.longDescription': 'This channel offers a variety of premium video clips for your creative projects.',
    'channel.licenseInfo': 'License Information',
    'channel.licenseDescription': 'All content on this channel is available under our standard license.',
    'channel.notFound': 'Channel Not Found',
    'channel.notFoundDescription': 'The channel you are looking for does not exist or has been removed',
    'channel.noPlaylists': 'This channel does not have any playlists yet',
    'channel.noClips': 'No clips available in this channel',
    'explore.channels.title': 'Premium Content Channels',
    'explore.channels.description': 'Discover high-quality video content from our premium channels',
    'channels.description': 'Browse and discover high-quality licensed content channels',
    'channels.noChannels': 'No channels found.'
  },
  fr: {
    'channels.allChannels': 'Toutes les Chaînes',
    'channels.searchPlaceholder': 'Rechercher des chaînes...',
    'channels.view': 'Voir la Chaîne',
    'channel.subscribe': 'S\'abonner',
    'channel.subscribers': 'abonnés',
    'channel.clips': 'clips',
    'channel.playlists': 'Playlists',
    'channel.recentClips': 'Clips Récents',
    'channel.about': 'À Propos',
    'channel.aboutTitle': 'À Propos de cette Chaîne',
    'channel.longDescription': 'Cette chaîne propose une variété de clips vidéo premium pour vos projets créatifs.',
    'channel.licenseInfo': 'Informations de Licence',
    'channel.licenseDescription': 'Tout le contenu de cette chaîne est disponible sous notre licence standard.',
    'channel.notFound': 'Chaîne Non Trouvée',
    'channel.notFoundDescription': 'La chaîne que vous recherchez n\'existe pas ou a été supprimée',
    'channel.noPlaylists': 'Cette chaîne ne contient pas encore de playlists',
    'channel.noClips': 'Aucun clip disponible dans cette chaîne',
    'explore.channels.title': 'Chaînes de Contenu Premium',
    'explore.channels.description': 'Découvrez du contenu vidéo de haute qualité provenant de nos chaînes premium',
    'channels.description': 'Parcourez et découvrez des chaînes de contenu sous licence de haute qualité',
    'channels.noChannels': 'Aucune chaîne trouvée.'
  }
};
